// extracted by mini-css-extract-plugin
module.exports = {"root":"Tooltip_root__9bXxy","typography":"Tooltip_typography__GEhzs"};